import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const BuildersRiskPost = () => (
  <div className="min-h-screen bg-slate-900">
    <Navbar />
    <section className="pt-32 pb-12 bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link to="/blog" className="inline-flex items-center gap-2 text-green-400 text-sm font-semibold hover:text-green-300 transition-colors mb-8 cursor-pointer">
          <i className="ri-arrow-left-line"></i> Back to Blog
        </Link>
        <span className="px-3 py-1 bg-green-500/10 border border-green-500/20 text-green-400 text-xs font-semibold rounded-full">Construction Insurance</span>
        <h1 className="text-4xl md:text-5xl font-bold text-white mt-4 mb-4 leading-tight">Builder's Risk Insurance: What Pennsylvania Contractors Need to Know</h1>
        <div className="flex items-center gap-4 text-slate-400 text-sm mb-8">
          <span><i className="ri-calendar-line mr-1 text-green-400"></i>February 2, 2026</span>
          <span><i className="ri-time-line mr-1 text-green-400"></i>5 min read</span>
          <span><i className="ri-map-pin-line mr-1 text-green-400"></i>Pennsylvania</span>
        </div>
        <div className="w-full h-64 rounded-2xl overflow-hidden mb-10">
          <img src="https://public.readdy.ai/ai/img_res/871dfa4853c1cab30fe6961aea011021.jpg" alt="Builder's risk insurance for Pennsylvania construction projects" className="w-full h-full object-cover object-top" />
        </div>
      </div>
    </section>
    <article className="py-12 bg-slate-900">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-slate-300 leading-relaxed space-y-6">
          <p className="text-lg text-slate-200">Builder's risk insurance is one of the most important — and most misunderstood — coverages in the construction industry. If you're a contractor or developer working on a project in Bucks County or Montgomery County, here's what you need to know about this essential policy.</p>

          <h2 className="text-2xl font-bold text-white mt-10 mb-4">What Is Builder's Risk Insurance?</h2>
          <p>Builder's risk insurance (also called course of construction insurance) is a specialized property policy that covers a building or structure while it's under construction. It protects against physical loss or damage to the project from covered perils such as fire, wind, theft, vandalism, and certain water damage events.</p>
          <p>Unlike a standard commercial property policy, builder's risk is designed specifically for the unique exposures of a construction project — including materials stored on-site, materials in transit, and the structure itself as it's being built.</p>

          <h2 className="text-2xl font-bold text-white mt-10 mb-4">Who Needs Builder's Risk Coverage?</h2>
          <p>Builder's risk policies can be purchased by:</p>
          <ul className="list-disc list-inside space-y-2">
            <li><strong className="text-white">General contractors</strong> — often required by the project owner or lender</li>
            <li><strong className="text-white">Property owners/developers</strong> — protecting their investment during construction</li>
            <li><strong className="text-white">Subcontractors</strong> — when they have an insurable interest in the project</li>
          </ul>
          <p>Lenders financing construction projects in Pennsylvania almost always require builder's risk coverage as a condition of the loan.</p>

          <h2 className="text-2xl font-bold text-white mt-10 mb-4">What Does Builder's Risk Cover?</h2>
          <p>A standard builder's risk policy covers:</p>
          <ul className="list-disc list-inside space-y-2">
            <li>The structure under construction</li>
            <li>Materials and supplies on-site</li>
            <li>Materials in transit to the job site</li>
            <li>Temporary structures (scaffolding, fencing)</li>
            <li>Soft costs (architect fees, permit costs) — with an endorsement</li>
          </ul>

          <h2 className="text-2xl font-bold text-white mt-10 mb-4">Common Exclusions</h2>
          <p>Builder's risk policies typically exclude:</p>
          <ul className="list-disc list-inside space-y-2">
            <li>Faulty workmanship or design errors</li>
            <li>Employee theft (covered under a crime policy)</li>
            <li>Flood and earthquake (available as endorsements)</li>
            <li>Mechanical breakdown of equipment</li>
          </ul>

          <h2 className="text-2xl font-bold text-white mt-10 mb-4">Top Carriers for Builder's Risk in Pennsylvania</h2>
          <p>The Stoll Agency places builder's risk policies with leading carriers including <a href="https://www.travelers.com/business-insurance/builders-risk" target="_blank" rel="noopener noreferrer nofollow" className="text-green-400 hover:text-green-300 underline transition-colors">Travelers</a>, <a href="https://www.thehartford.com" target="_blank" rel="noopener noreferrer nofollow" className="text-green-400 hover:text-green-300 underline transition-colors">The Hartford</a>, and <a href="https://www.libertymutual.com" target="_blank" rel="noopener noreferrer nofollow" className="text-green-400 hover:text-green-300 underline transition-colors">Liberty Mutual</a>. We'll match your project type, size, and timeline with the right carrier and coverage structure.</p>

          <div className="bg-slate-800 border border-green-500/30 rounded-2xl p-6 mt-10">
            <h3 className="text-xl font-bold text-white mb-2">Get a Builder's Risk Quote</h3>
            <p className="text-slate-400 text-sm mb-4">Starting a new project in Bucks County or Montgomery County? Contact us for a fast builder's risk quote.</p>
            <Link to="/contact" className="inline-flex items-center px-6 py-3 bg-green-500 text-white rounded-full font-semibold hover:bg-green-400 transition-all text-sm whitespace-nowrap cursor-pointer">
              Request a Quote <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </div>
    </article>
    <Footer />
  </div>
);

export default BuildersRiskPost;
